import React, { useRef, useEffect } from 'react';
import { FiSend, FiMic, FiMicOff, FiLoader } from 'react-icons/fi';
import { WaveVisualizer } from '../Common/WaveVisualizer';
import './MessageInput.css';

export function MessageInput({
  inputMessage,
  setInputMessage,
  onSendMessage,
  isLoading,
  isListening,
  onToggleVoice,
  voiceTranscript,
}) {
  const inputRef = useRef(null);

  // Auto focus input on mount
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  // Update input text if interim voice transcript arrives
  useEffect(() => {
    if (voiceTranscript) {
      setInputMessage(voiceTranscript);
    }
  }, [voiceTranscript, setInputMessage]);

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (!inputMessage.trim() || isLoading) return;
    onSendMessage(inputMessage.trim());
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <form className="message-input-form" onSubmit={handleSubmit}>
      <div className={`message-input-wrapper ${isListening ? 'listening-active' : ''} ${isLoading ? 'loading' : ''}`}>
        
        {/* Voice Listening Ripple Indicator */}
        {isListening && (
          <div className="voice-wave-indicator">
            <WaveVisualizer active={true} color="amber" barsCount={6} />
            <span className="listening-tag">Listening...</span>
          </div>
        )}

        <input
          ref={inputRef}
          type="text"
          className="message-text-field"
          placeholder={isListening ? 'Speak now, listening to voice...' : 'Ask about training, services, or products...'}
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={isLoading}
        />

        <div className="input-action-buttons">
          {/* Voice Dictation Button */}
          <button
            type="button"
            className={`input-action-btn mic-btn ${isListening ? 'is-listening' : ''}`}
            onClick={onToggleVoice}
            disabled={isLoading}
            title={isListening ? 'Stop Voice Input' : 'Speak Query'}
          >
            {isListening ? <FiMicOff className="btn-icon pulse" /> : <FiMic className="btn-icon" />}
          </button>

          {/* Submit / Send Button */}
          <button
            type="submit"
            className="input-action-btn send-btn"
            disabled={!inputMessage.trim() || isLoading}
            title="Send Message (Enter)"
          >
            {isLoading ? <FiLoader className="btn-icon spin" /> : <FiSend className="btn-icon" />}
          </button>
        </div>
      </div>
    </form>
  );
}
